<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <groupsidebar></groupsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper">
          <div class="moduleCard">

            <div v-if="grouptags!==null">
              <h2 class="mb-4" id="group_tags">Group Tags</h2>
              <div class="row mt-2" v-show="grouptags.length>0" v-for="grouptag in grouptags">
                <div class="col-4">
                  {{grouptag.TagName}}
                </div>
                <div class="col-2">
                  <button v-show="IsPoolAdmin===true" class="btn-transparent" @click="doRemoveGroupTag(grouptag.LicensePoolTagID,grouptag.LicensePoolGroupTagID)"><font-awesome-icon icon="times"></font-awesome-icon></button>
                </div>
                <div class="col-6">&nbsp;</div>
              </div>
              <div v-show="grouptags.length===0" id="no_tag_assigned_to_group">
                There are no tags assigned to this group
              </div>
            </div>
            <div class="row mt-2" v-if="possibleGroupTags!==null&&possibleGroupTags.length>0&&IsPoolAdmin===true">
              <div class="col-4">
                <select v-model="newGroupTag" class="fullWidth" id="ddlGroupTag">
                  <option v-for="gt in possibleGroupTags" v-bind:value="gt.LicensePoolTagID">{{gt.TagName}}</option>
                </select>
              </div>
              <div class="col-2">
                <button class="btn btn-secondary btn-short" @click="doAddGroupTag" id="add">Add</button>
              </div>
              <div class="col-6">
                &nbsp;
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
    </div><acfooter></acfooter>
  </div>
</template>
<script>
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import groupsidebar from "../../layout/Group/Sidebar.vue"

  export default {
    name: 'GroupTags',
    components: { acheader, acfooter, groupsidebar },
    data() {
      return {
        IsAdmin: false,
        grouptags: null,
        newGroupTag: null,
        possibleGroupTags: null,
        IsPoolAdmin: false
      }
    },
    methods: {
      doAddGroupTag() {

        if (this.newGroupTag === null) {
          this.popDialog(1, "Please select a tag");
          return;
        }

        this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "AddTagToGroup",
            Fields: {
              LicensePoolTagID: this.newGroupTag,
              LicensePoolID: this.sdata.activegroup.LicensePoolID,
              LicensePoolGroupID: this.$route.params.id
            }
          }
        ]).then(r => {
          this.popDialog(0, "Tag added successfully");
          this.render();
        });
      },
      doRemoveGroupTag(tagID, groupTagID) {
        this.$bvModal.msgBoxConfirm('Are you sure you want to delete this Group tag?', {
          title: 'Confirm Deletion',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Delete',
          cancelTitle: 'Cancel',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
          modalClass:"remove_item_model"
        }).then(value => {
          if (value) {
            this.apiCommand([
              {
                Operation: "LicensePool",
                Function: "RemoveTagFromGroup",
                Fields: {
                  LicensePoolTagID: tagID,
                  LicensePoolID: this.sdata.activegroup.LicensePoolID,
                  LicensePoolGroupID: this.$route.params.id,
                  LicensePoolGroupTagID: groupTagID
                }
              }
            ]).then(r => {
              this.popDialog(0, "Tag removed successfully");
              this.render();
            });
          }
        });
        setTimeout("Window.loadLanguageContent()", 500);
      },
      render() {
        this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "GetTagsForGroup",
            Fields: {
              LicensePoolID: this.sdata.activegroup.LicensePoolID,
              LicensePoolGroupID: this.$route.params.id
            }
          },
          {
            Operation: "LicensePool",
            Function: "GetTags",
            Fields: {
              LicensePoolID: this.sdata.activegroup.LicensePoolID
            }
          }
        ]).then(r => {
          var cr = JSON.parse(r.CommandResult);
          this.grouptags = JSON.parse(cr.returnObjects[0].returnObject);
          var pgt = JSON.parse(cr.returnObjects[1].returnObject);
          pgt.unshift({
            LicensePoolTagID: null,
            TagName: "--- Select ---"
          });
          this.possibleGroupTags = pgt;
          setTimeout("Window.loadLanguageContent()", 500);
        });
      }
    },
    mounted() {
      this.doPage().then(r => {
        this.bootstrapGroup(this.$route.params.id);        
        this.IsAdmin = this.sdata.activegroup.IsAdmin;
        if (this.sdata.allpools.length>0) {
          this.IsPoolAdmin = true;
        }
        this.render();
        setTimeout("Window.loadLanguageContent()", 500);
      });
    }
  }
</script>
